export default "__VITE_ASSET__ZriMXoYA__"